module.exports = __webpack_public_path__ + "img/anniversary_look_btn.a2517509.png";